<script>

export default {
    props: {
        occasionTypeId: {
            type: Number,
            default: null
        },
        occasionTagId: {
            type: Number,
            default: null
        },
    },

    data() {
        return {
            occTags: null,
            occTagId: null,
        }
    },
    created() {
        this.occTags = [
            {
                label: '--All Distances--',
                id: null
            }
        ]


        let
            qString = window.location.search,
            occTypeId = this.getDataFromQueryString()
        ;

        if (occTypeId) {
            this.getData(occTypeId);
        } else {
            if (this.occasionTypeId) this.getData(this.occasionTypeId);
            if (this.occasionTagId) this.occTagId = this.occasionTagId;
        }
    },
    methods: {
        getDataFromQueryString() {
            const urlParams = new URLSearchParams(window.location.search);
            let occTypeId = urlParams.get('occasion_type_id');
            this.occTagId = urlParams.get('occasion_tag_id');
            return occTypeId;
        },
        handleChange(event) {
            let value = event.target.value;
            this.getData(value);
        },
        async getData(value) {
            if (!value) {
                this.occTagId = null;
            }
            this.occTags = [];
            let res = await axios.get('/api/internal/occasion_tags.json?occasion_type_id=' + value);
            let tagsIds = [];
            this.occTags.push({
                label: '--All Distances--',
                id: null
            });

            let found = false;

            await res.data.data.forEach((item) => {
                let option = {};
                if (this.occTagId == item.id) {
                    found = true;
                }
                tagsIds.push(item.id);
                option.id = item.id;
                option.label = item.name;
                this.occTags.push(option);
            });

            if (found === false) {
                this.occTagId = null
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/OccasionSearch.vue